import cx from 'classnames';
import { ReactNode } from 'react';

type TitleProps = {
  kind?: 'blue' | 'lightGray' | 'green' | 'white' | 'blue-tim' | 'soft-blue';
  children?: ReactNode;
  className?: string;
  dataIcTitle?: string;
};

const Title = ({ kind, children, className, dataIcTitle }: TitleProps) => {
  const classNames = cx(className, {
    'bg-tim-primary text-white': kind === 'blue',
    'bg-tim-green text-white': kind === 'green',
    'bg-gray-300 text-gray-700': kind === 'lightGray',
    'bg-white text-tim-primary': kind === 'white',
    'bg-tim-blue_tim': kind === 'blue-tim',
    'bg-tim-soft_blue text-white': kind === 'soft-blue',
  });

  return (
    <div className={classNames} data-ic-title={dataIcTitle}>
      {children}
    </div>
  );
};

export default Title;
